<template>
	<div class="intro-layout">
		<alert></alert>
		<child/>

    <subscription-modal-container v-if="$auth.user().external_user" :intro="true"></subscription-modal-container>
	</div>
</template>

<script>
export default {
	name: 'intro-layout',

	mounted () {
		if (process.env.NODE_ENV === 'production') {
			const _this = this
			window.FS.identify(_this.$auth.user().id, {
				displayName: _this.$auth.user().firstname + ' ' + _this.$auth.user().surname,
				email: _this.$auth.user().email
			})
		}
	}
}
</script>

<style lang="scss">
	.intro-layout {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100vh;
	}
</style>



// WEBPACK FOOTER //
// src/layouts/intro.vue